import React from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import CourseBlock from "./CourseBlock";
import CourseBundleDescription from "./CourseBundleDescription";
import CourseCarousel from "./CourseCarousel";

function CoursesListSlide({className}) {
  return (
    <div className={`${className || ""}`} >
      <>
        <Row className="align-items-center">
          <Col md={12} xl={12}>
            <CourseCarousel />
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="mb-4">
            <CourseBundleDescription className="mt-4 mb-4" courseBundleDescTitle="Description for bundle" courseBundleDesc="The HIPAA Basics course will introduce you to the Health Insurance Portability and Accountability Act of 1996 or HIPAA in a simple yet informative way. This course also focuses on helping the learner gain an understanding of the following topics:"/>
          </Col>
        </Row>
      </>
    </div>
  );
}

export default CoursesListSlide;
